import React from "react";
import styled from "styled-components";
import { H4, H6, P } from "@upsolve/ui";

const FAQPanel = ({ faqs = [] }) => (
  <StyledFAQPanel>
    <div className="faq__header">
      <label>Frequently Asked Questions</label>
    </div>
    {faqs.map(({ answer, component, question }, faqIndex) => (
      <section key={faqIndex} className="faq__item">
        <div className="faq__item__question">
          <H6 as="label">{question}</H6>
        </div>
        <div className="faq__item__answer">{component != null ? component : <P>{answer}</P>}</div>
      </section>
    ))}
  </StyledFAQPanel>
);

const StyledFAQPanel = styled.div`
  width: auto;
  padding: 1.5em 2em;
  margin: 1em 3em;
  border-radius: 8px;
  border: 1px solid ${(props) => props.theme.colors.white[700]};
  background: ${(props) => props.theme.colors.white[900]};
  .faq__header {
    width: 100%;
    padding: 0 0 0.5em;
    border-bottom: 1px solid ${(props) => props.theme.colors.white[300]};
    & > label {
      color: ${(props) => props.theme.colors.brand[500]};
      font-weight: 500;
    }
  }
  .faq__item {
    margin: 1em 0 0 1.5em;
    padding: 1em 0 0 1em;
    border-left: 1px solid ${(props) => props.theme.colors.brand[500]};
    border-bottom: 1px solid ${(props) => props.theme.colors.white[500]};
  }
  .faq__item__question {
    margin-bottom: 0.5em;
    color: ${(props) => props.theme.colors.brand[500]};
  }
  .faq__item__answer {
    p {
      margin: 0;
      font-size: 15px;
      line-height: 140%;
      color: ${(props) => props.theme.colors.gray[900]};
    }
  }
  @media (max-width: ${(props) => props.theme.breakpoints[500]}) {
    margin: 1em auto;
  }
`;

export default FAQPanel;
